/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/bankid_mobile_medium'
export default icon
